// extracted by mini-css-extract-plugin
export default {"grid":"SectionContacts_grid__qfKK5","cell":"SectionContacts_cell__qhsNc","title":"SectionContacts_title__csUyp","description":"SectionContacts_description__OzK++"};